import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Switch from 'react-bootstrap-switch';

import I18n from 'PMT/i18n/I18n';

import { ProductOptionValue } from 'PMT/entities/menu';

import { Utils } from 'PMT/utils';

import { Modal } from 'react-bootstrap';
import {
  TextInput,
  NumberInput,
  TextInputLocalized,
} from 'PMT/components/form';
import AbstractFormComponent from 'components/form/AbstractFormComponent';

import Constants from 'constants/Constants';
import AllergenChooser from 'PMT/components/form/AllergenChooser';

import SecurityContext from 'utils/permissions/SecurityContext';
import {CurrencyUtils} from 'PMT/utils';

export default class EditProductOptionValueModal extends AbstractFormComponent {
  static defaultProps = {
    productOptionValue: new ProductOptionValue(),
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    productOptionValue: PropTypes.instanceOf(ProductOptionValue),

    isEditMode: PropTypes.bool.isRequired,

    /**
     * @param ProductOptionValue
     */
    onUpdate: PropTypes.func,

    /**
     * @param ProductOptionValue
     */
    onCreate: PropTypes.func,

    /**
     * @param ProductOptionValue
     */
    onDelete: PropTypes.func,

    currencyCode: PropTypes.string,

    canFullyEditOptionValues: PropTypes.bool.isRequired,

    canEditOptionValueNames: PropTypes.bool.isRequired,


  };

  state = this.getDefaultState(this.props);

  get productOptionValue(): ProductOptionValue {
    return this.state.productOptionValue;
  }

  getDefaultState() {
    return {
      productOptionValue: this.props.productOptionValue.copy(),

      /*
       * contains the productOption.getValidationErrors() when submit the form
       */
      validationErrors: {},
    };
  }

  //
  //
  //

  haveModifications(): boolean {
    return !this.props.productOptionValue.equals(this.state.productOptionValue);
  }

  shouldDisableSubmit(): boolean {
    return !this.productOptionValue.isValid();
  }

  isEditMode(): boolean {
    return this.props.isEditMode;
  }

  //
  // Modal
  //

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  //
  //
  //

  onDeleteProductOptionValue = (event) => {
    event.preventDefault();

    this.props.onDelete(this.props.productOptionValue);
    this.props.onHide();
  };

  onChange = (productOptionValue: ProductOptionValue) => {
    this.setState({
      productOptionValue,
    });
  };

  onNameChange = (newValue: string) => {
    const productOptionValue: ProductOptionValue = this.productOptionValue;
    productOptionValue.localizedNames = newValue;
    this.onChange(productOptionValue);
  };

  onAdditionalPriceChange = (newValue: number) => {
    const productOptionValue: ProductOptionValue = this.productOptionValue;
    productOptionValue.additionalPrice = newValue;
    this.onChange(productOptionValue);
  };

  onAllergensChange = (allergens) => {
    const productOptionValue: ProductOptionValue = this.productOptionValue;
    if (!productOptionValue.dietaryData) {
      productOptionValue.dietaryInfo = {};
    }
    productOptionValue.dietaryInfo.allergens = allergens;
    this.onChange(productOptionValue);
  };

  onToggleStock = () => {
    if (
      !SecurityContext.restaurantMenu.canEdit() &&
      !SecurityContext.restaurantMenu.canEditAvailabilityProducts()
    ) {
      return;
    }

    const productOptionValue: ProductOptionValue = this.productOptionValue;

    productOptionValue.toggleAvailibility();

    this.onChange(productOptionValue);
  };

  onSubmit = (event) => {
    event.preventDefault();

    const productOptionValue: ProductOptionValue = this.productOptionValue;

    /**
     * We need to create a unique pos id if  we create a new productOption
     */
    if (!this.isEditMode()) {
      productOptionValue.id = Utils.generateUID();

      /**
       * Activated by default.
       * @type {boolean}
       */
      //    productOption.activated = true;
    } else {
      productOptionValue.id = this.props.productOptionValue.id;
    }

    if (productOptionValue.isValid()) {
      if (this.isEditMode()) {
        this.props.onUpdate(productOptionValue);
        this.onClose();
      } else {
        this.props.onCreate(productOptionValue);
        this.onClose();
      }
    } else {
      const validationErrors = productOptionValue.getValidationErrors();
      console.info('productOption invalid', validationErrors);
      this.setState({
        validationErrors,
      });
    }
  };

  //
  get title(): string {
    if (!this.isEditMode()) {
      return I18n.tr('menu.product_option.option.value.new_choice');
    }
    return I18n.tr('menu.product_option.option.value.edit_choice');
  }

  //
  // renderers
  //

  renderName() {
    return (
      <div className="form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('menu.product_option.option.value.name')}</label>
        </div>
        <div className="col-xs-6">
          <TextInputLocalized
            locales={Constants.localesForTranslation}
            values={this.productOptionValue.localizedNames}
            isRequired
            className="form-control"
            placeholder={I18n.tr('menu.product_option.option.value.name')}
            onChange={this.onNameChange}
          />
        </div>
        <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.name}
        </div>
      </div>
    );
  }

  renderAdditionalPrice() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>
            {I18n.tr('menu.product_option.option.value.additionnal_price')}
          </label>
        </div>

        <div className="col-xs-6">
          <div className="input-group">
            <NumberInput
              value={this.productOptionValue.additionalPrice}
              onChange={this.onAdditionalPriceChange}
              min={0}
              disabled={!this.props.canFullyEditOptionValues}
            />
            <div className="input-group-addon">
              {CurrencyUtils.getCurrencySymbol(this.props.currencyCode)}
            </div>
          </div>
        </div>

        <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.additionalPrice}
        </div>
      </div>
    );
  }

  renderDelete() {
    if (!this.isEditMode() || !this.props.canFullyEditOptionValues) {
      return null;
    }

    return (
      <div className="top-buffer-50 text-left">
        <button
          type="submit"
          className="btn btn-danger"
          onClick={this.onDeleteProductOptionValue}
        >
          {I18n.tr('menu.product_option.option.value.delete_value')}
        </button>
      </div>
    );
  }

  renderAllergens() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('global.allergen.allergens')}</label>
        </div>

        <div className="col-xs-6">
          <AllergenChooser
            allergens={
              this.productOptionValue.dietaryInfo
                ? this.productOptionValue.dietaryInfo.allergens
                : []
            }
            onChange={this.onAllergensChange}
            readOnly={!this.props.canFullyEditOptionValues}
          />
        </div>
      </div>
    );
  }

  renderStock() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('menu.product_option.option.value.stock')}</label>
        </div>

        <div className="col-xs-6">
          <Switch
            bsSize="mini"
            wrapperClass="switch_important"
            value={this.productOptionValue.haveStock()}
            onChange={this.onToggleStock}
            disabled={
              !(this.props.canFullyEditOptionValues
                  || SecurityContext.restaurantMenu.canEditAvailabilityProducts())
            }
          />
        </div>
      </div>
    );
  }

  renderBody() {
    return (
      <form
        className="form form-horizontal product_pption_value_edit_form"
        role="form"
        noValidate
      >
        {this.renderName()}
        {this.renderAdditionalPrice()}
        {this.renderAllergens()}
        {this.renderStock()}

        <div className="top-buffer-50 text-center">{this.renderButtons()}</div>

        {this.renderDelete()}
      </form>
    );
  }

  render() {
    try {
      return (
        <Modal bsSize="large" show={this.props.show} onHide={this.onHide}>
          <Modal.Header>
            <button
              type="button"
              className="close close-white"
              onClick={this.props.onHide}
            >
              <span aria-hidden="true">×</span>
            </button>

            <Modal.Title>{this.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.renderBody()}</Modal.Body>
        </Modal>
      );
    } catch (e) {
      console.error(e);
    }
  }
}
